/**
 * Created by newb on 18/12/06.
 */

export { formatDate, sortDate, UTCTimeToDate, timestampToTime, getDays, formatTimeStamp,copyToClipboard }
import { Message } from 'element-ui';
import dayjs from "dayjs"

/**
 *  日期格式化
 * @param date  Date对象
 * @param format  格式， 如'yyyy-MM-dd HH-mm-ss 星期w'
 * @returns {*}
 */
function formatDate(date, format) {
  let choice = {
    yyyy: date.getFullYear(),
    yy: date
      .getFullYear()
      .toString()
      .slice(-2),
    MM: ('0' + (date.getMonth() + 1)).slice(-2),
    M: date.getMonth() + 1,
    dd: ('0' + date.getDate()).slice(-2),
    d: date.getDate(),
    HH: ('0' + date.getHours()).slice(-2),
    H: date.getHours(),
    hh: ('0' + (date.getHours() % 12)).slice(-2),
    h: date.getHours() % 12,
    mm: ('0' + date.getMinutes()).slice(-2),
    m: date.getMinutes(),
    ss: ('0' + date.getSeconds()).slice(-2),
    s: date.getSeconds(),
    w: ['日', '一', '二', '三', '四', '五', '六'][date.getDay()]
  }
  return format.replace(/[A-z]+/g, function (str) {
    return choice[str]
  })
}

/**
 * 日期格式化
 * @param {string} timestamp  秒时间戳
 * @param {string} format  格式， 如'YYYY-MM-DD HH-mm-ss'
 * @returns {*} 格式化后字符串
 */
function formatTimeStamp(timestamp, format) {
  const timeNum = Number(timestamp)
  if (Number.isNaN(timeNum)) return timestamp
  return dayjs(timestamp * 1000).format(format)
}

/**
 * 比较两个日期大小
 * @param a  yyyy-MM-dd
 * @param b   yyyy-MM-dd
 */
function sortDate(a, b) {
  const arr1 = a.split('-')
  const arr2 = b.split('-')
  let i = 0
  while (i < arr1.length) {
    if (arr1[i] === arr2[i]) {
      i++
    } else {
      return arr1[i] - arr2[i]
    }
  }
  return false
}

/**
 * 转化UTC时间戳
 * @param time  时间戳
 * @param format   日期格式
 */
function UTCTimeToDate(time, format) {
  let myDate = new Date()
  myDate.setTime(parseInt(time) * 1000 - 8 * 3600 * 1000)
  format = format ? format : 'yyyy-MM-dd HH:mm:ss'
  return formatDate(myDate, format)
}

function timestampToTime(timestamp) {
  var date = new Date(timestamp * 1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + '-'
  let M =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + '-'
  let D = date.getDate() + ' '
  let h = date.getHours() + ':'
  let m = date.getMinutes() + ':'
  let s = date.getSeconds()
  return Y + M + D + h + m + s
}

/**
 * 获得两个日期之间的所有日期
 * @param date1
 * @param date2
 */
function getDays(date1, date2) {
  date1 = getDateFromStr(date1)
  date2 = getDateFromStr(date2)

  let time1 = date1.getTime()
  let time2 = date2.getTime()

  let interval = 24 * 3600 * 1000

  let res = []
  for (let i = time1; i <= time2; i += interval) {
    let date = new Date(i)
    res.push(formatDate(date, 'yyyy-MM-dd'))
  }
  return res
}

/**
 * 根据日期获取Date对象
 * @param dateStr  'yyyy-MM-dd'格式日期
 */
function getDateFromStr(dateStr) {
  let strArr = dateStr.split('-')
  let date = new Date(strArr[0], parseInt(strArr[1]) - 1, strArr[2])
  return date
}

const copyToClipboard = (text, desc="复制成功") => {
  // 创建一个临时的textarea元素
  const textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  // 选中文本
  textArea.select();
  textArea.setSelectionRange(0, 99999); // 适用于移动设备
  // 执行复制命令
  document.execCommand("copy");

  // 删除临时元素
  document.body.removeChild(textArea);
  // 弹出提示
  Message.success(desc)
}
